import {
    QUALIFICATION_VIEW_ALL, QUALIFICATION_VIEW_ALL_ERROR,
    QUALIFICATION_VIEW_ONE, QUALIFICATION_VIEW_ONE_ERROR
} from "./type";

const initialState = {
    qualifications: [],
    qualification: {},
    qualificationsError: null,
    qualificationError: null,
};

export const qualificationReducer = (
    state = initialState,
    { type, payload }
) => {
    switch (type) {
        case QUALIFICATION_VIEW_ALL:
            return { ...state, qualifications: payload };
        case QUALIFICATION_VIEW_ALL_ERROR:
            return { ...state, qualificationsError: payload };
        case QUALIFICATION_VIEW_ONE:
            return { ...state, qualification: payload };
        case QUALIFICATION_VIEW_ONE_ERROR:
            return { ...state, qualificationError: payload };
        default:
            return state;
    }
};
